import 'modernizr.custom';

export default window.Modernizr;
